import React from 'react';
import { ChevronLeft, ChevronRight } from 'react-feather';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) {
    return null;
  }

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <nav className="flex items-center justify-center gap-4 mt-16" aria-label="Pagination">
      <button
        onClick={handlePrevious}
        disabled={currentPage === 1}
        className="flex items-center justify-center w-10 h-10 rounded-full border border-white/10 bg-white/5 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-white/10 transition-colors"
        aria-label="Go to previous page"
      >
        <ChevronLeft size={20} />
      </button>

      <span className="text-sm text-white/70" aria-live="polite">
        Page {currentPage} of {totalPages}
      </span>

      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        className="flex items-center justify-center w-10 h-10 rounded-full border border-white/10 bg-white/5 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-white/10 transition-colors"
        aria-label="Go to next page"
      >
        <ChevronRight size={20} />
      </button>
    </nav>
  );
};

export default Pagination;
